import React, { /*ForwardRefRenderFunction, */ useRef, useState } from 'react';
import {
  IonButton,
  IonContent,
  IonFooter,
  IonItem,
  // IonList,
  IonPage,
  IonToast,
  IonToolbar,
} from '@ionic/react';
import './AppSettings.scoped.scss';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { homepageSelector } from '../../store/slices';
import BackButton from '../../components/BackButton/BackButton';
import SettingsForm, { SettingsFormRef } from '../../components/SettingsForm/SettingsForm';

const AppSettings: React.FC = () => {
  const { t } = useTranslation();
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const homepage = useSelector(homepageSelector);

  const form = useRef<SettingsFormRef>(null);

  const onSaveSettings = () => {
    // Call ref form and tell it to save
    form.current?.onSaveSettings();
    setShowToast(true);
    setToastMessage('Settings saved');
  };

  return (
    <IonPage>
      <IonContent className="app-settings-content">
        <div className="back-button-wrapper">
          <BackButton defaultPath={homepage} />
        </div>
        <SettingsForm ref={form}></SettingsForm>
      </IonContent>
      <IonFooter className="ion-no-border app-settings-footer">
        <IonToolbar className="ion-no-padding" color="none">
          <IonItem lines="none" color="none" className="ion-no-margin ion-no-padding">
            <IonButton className="primary-type-button center-button" onClick={onSaveSettings}>
              {t('Save')}
            </IonButton>
          </IonItem>
        </IonToolbar>
      </IonFooter>
      <IonToast
        isOpen={showToast}
        onDidDismiss={() => setShowToast(false)}
        message={t(toastMessage)}
        duration={2000}
      />
    </IonPage>
  );
};

export default AppSettings;
